import { Caixa, CaixaTransferencia, error99, RetAPI } from '../../Utils/Types'
import { Api } from '../../Utils/api'
import { DataSearch } from '../../Components/SearchBox/SearchBox'

export type ExtratoConta = {
    saldoAnterior: number,
    saldoAtual: number,
    totEnt: number,
    totSai: number,
    extrato: Caixa[],
}

export const LanctoCaixaService = {

    GetAttributes: async (): Promise<RetAPI> => {

        const resp = await Api('Caixa/Attributes', 'get')
        const contas: DataSearch[] = []

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {

                return {
                    error: true,
                    msg: resp.data.msg || '',
                    data: contas
                }
            }

            if (resp.data.error && resp.data.error === '0') {

                if (resp.data.contas) {

                    await resp.data.contas.map((item: any) => {
                        contas.push({
                            id: item.id,
                            description: item.descricao,
                        })
                    })
                }
            }

        } else {

            return {
                error: true,
                msg: "Nenhuma informação retornada",
                data: contas
            }

        }

        return {
            error: false,
            data: contas
        }

    },

    Save: async (caixa: Caixa): Promise<RetAPI> => {
        const resp = await Api('Caixa/Save', 'post', { data: caixa.data, tipo: caixa.tipo, valor: caixa.valor, historico: caixa.historico, id_conta: caixa.idConta, tipo_lancto: caixa.tipoLancto })

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {
                return {
                    error: true,
                    msg: resp.data.msg || '',
                }
            }

            return {
                error: false,
                msg: '',
                data: resp.data.controle_conta
            }

        } else {

            return {
                error: true,
                msg: "Nenhuma informação retornada",
            }
        }
    },

    Extrato: async (datai: string, dataf: string, tipo: string, idConta: number): Promise<RetAPI> => {

        const resp = await Api('Caixa/Extrato', 'get', { datai, dataf, id_conta: idConta, tipo })

        const extrato: ExtratoConta = {
            saldoAnterior: 0,
            saldoAtual: 0,
            totEnt: 0,
            totSai: 0,
            extrato: [],
        }

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {
                return {
                    error: true,
                    msg: resp.data.msg || '',
                    data: extrato
                }
            }

            if (resp.data.error && resp.data.error === '0') {

                extrato.saldoAnterior = resp.data.saldo_anterior
                extrato.saldoAtual = resp.data.saldo_atual
                extrato.totEnt = resp.data.entradas
                extrato.totSai = resp.data.saidas

                await resp.data.extrato.map((item: any) => {
                    extrato.extrato.push({
                        id: item.id,
                        data: item.data,
                        valor: item.valor,
                        historico: item.historico,
                        dtCadastro: '',
                        nameUserInsert: '',
                        tipo: item.tipo,
                        idConta: item.id_conta,
                        desc_conta: item.desc_conta,
                        acumulado: item.acumulado,
                        tipoLancto: item.tipo_lancto
                    })
                }

                )

            }

        } else {

            return {
                error: true,
                msg: "Nenhuma informação retornada",
                data: extrato
            }
        }

        return {
            error: false,
            msg: '',
            data: extrato
        }

    },

    Transferencia: async (caixa: CaixaTransferencia): Promise<RetAPI> => {
        const resp = await Api('Caixa/Transferencia', 'post', { id_conta_origem: caixa.idContaOrigem, id_conta_destino: caixa.idContaDestino, valor: caixa.valor, historico: caixa.historico, data: caixa.data })

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {
                return {
                    error: true,
                    msg: resp.data.msg || '',
                }
            }

            return {
                error: false,
                msg: '',
            }

        } else {

            return {
                error: true,
                msg: "Nenhuma informação retornada",
            }
        }
    },
}